var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_71311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#666666"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_71311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00195 2.67395L1.93865 3.35518C2.15164 3.51008 2.44825 3.47322 2.61685 3.27091L4.50927 1",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3999 8.81164L7.3366 9.49288C7.54958 9.64778 7.8462 9.61092 8.0148 9.4086L9.90722 7.1377",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5237 14.9493L12.4604 15.6306C12.6734 15.7855 12.97 15.7486 13.1386 15.5463L15.031 13.2754",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36807 2.375H11.4149C13.1065 2.375 14.4779 3.74635 14.4779 5.43799C14.4779 7.12963 13.1065 8.50098 11.4149 8.50098H10.5693V9.50098H11.4149C13.4895 9.50098 15.201 7.94603 15.4474 5.93799H15.4779V5.43799C15.4779 3.19406 13.6588 1.375 11.4149 1.375H5.36807V2.375ZM4.42595 8.50098H5V9.50098H4.42595C2.81 9.50098 1.5 10.811 1.5 12.4269C1.5 14.0429 2.80999 15.3529 4.42595 15.3529H10.7463V16.3529H4.42595C2.42709 16.3529 0.777135 14.8591 0.531539 12.9269H0.5V12.4269C0.5 10.2587 2.25771 8.50098 4.42595 8.50098Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon);
export default __webpack_public_path__ + "static/media/flow-icon.05acb2d9572757d3e7f3fd0f9f7c06dc.svg";
export { ForwardRef as ReactComponent };